import React, { useEffect } from 'react';
import FlickityWidget from '../widget/FlickityWidget';
import Chart from '../../util/chart';
import ApiService from '../../services/ApiService';

const PostedQuotesPie = () => {
  const getQuotesByStatus = () => {
    ApiService.get('crm/quotes/posted').then(response => {
      const dataProvider = [];

      response.data.forEach(data => {
        dataProvider.push({ label: data.QuoteState.name, value: data.cnt, color: data.QuoteState.color });
      });

      Chart.makePieChart('quote-status-pie', {
        titles: [
          {
            text: 'Posted This Month',
          },
        ],
        colorField: 'color',
        labelText: '[[value]]',
        dataProvider,
      });
    });
  };

  useEffect(() => {
    getQuotesByStatus();
  }, []);

  return (
    <FlickityWidget>
      <div id="quote-status-pie" className="stretch" />
    </FlickityWidget>
  );
};

export default PostedQuotesPie;
